import { Box } from "@mui/material";
import { canApplyDate, parseDate } from "Backend";
import PDatePicker from "components/PDatePicker";
import useSearchParamsWithUpdate from "helpers/hooks/useSearchParamsWithUpdate";
import { P } from "theme/typography";
import { sub } from "date-fns";

function getToday(): Date {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function getSunday(): Date {
  const today = getToday();
  return sub(getToday(), { days: today.getDay() });
}

function getYesterday(): Date {
  return sub(getToday(), { days: 1 });
}

interface DateRangeFilterProps {
  startLabel: string;
  startKey: string;
  endLabel: string;
  endKey: string;
}

const DateRangeFilter = ({ startLabel, startKey, endLabel, endKey }: DateRangeFilterProps) => {
  const { searchParams, updateParam } = useSearchParamsWithUpdate();
  const dateStart = searchParams.get(startKey);
  const dateEnd = searchParams.get(endKey);

  const setDate = (d: Date | undefined, param: string) => {
    if (canApplyDate(param, d, searchParams)) {
      updateParam(param, d?.toISOString() || "");
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", textAlign: "center", gap: "4px" }}>
      <PDatePicker
        date={parseDate(dateStart)}
        label={startLabel}
        setDate={(d) => setDate(d, startKey)}
        maxDate={parseDate(dateEnd)}
        slotProps={{
          shortcuts: {
            items: [
              {
                label: "Today",
                getValue: getToday,
              },
              {
                label: "Yesterday",
                getValue: getYesterday,
              },
              {
                label: "This Week",
                getValue: getSunday,
              },
            ],
          },
        }}
      />
      <P variant="body4">
        <i>to</i>
      </P>
      <PDatePicker
        date={parseDate(dateEnd)}
        label={endLabel}
        setDate={(d) => setDate(d, endKey)}
        minDate={parseDate(dateStart)}
      />
    </Box>
  );
};

export default DateRangeFilter;
